/*-
 * ========================LICENSE_START=================================
 * TeamApps
 * ---
 * Copyright (C) 2014 - 2026 TeamApps.org
 * ---
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *      http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================LICENSE_END==================================
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;

import {UiCommand} from "./UiCommand";
import {UiEvent} from "./UiEvent";
import {UiQuery} from "./UiQuery";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiTreeGraphNodeImageConfig} from "./UiTreeGraphNodeImageConfig";
import {UiTreeGraphNodeIconConfig} from "./UiTreeGraphNodeIconConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiClientRecordConfig} from "./UiClientRecordConfig";

export enum UiNetworkNode_ExpandState {
	NOT_EXPANDABLE, EXPANDED, COLLAPSED
}

export interface UiNetworkNodeConfig {
	_type?: string;
	id: string;
	width: number;
	height: number;
	backgroundColor?: string;
	borderColor?: string;
	borderWidth?: number;
	borderRadius?: number;
	distanceFactor?: number;
	image?: UiTreeGraphNodeImageConfig;
	icon?: UiTreeGraphNodeIconConfig;
	template?: UiTemplateConfig;
	record?: UiClientRecordConfig;
	expandState?: UiNetworkNode_ExpandState
}


